/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelQuoteRequest
 */
export interface CancelQuoteRequest {
    /**
     * 
     * @type {string}
     * @memberof CancelQuoteRequest
     */
    adminComment?: string;
}

/**
 * Check if a given object implements the CancelQuoteRequest interface.
 */
export function instanceOfCancelQuoteRequest(value: object): value is CancelQuoteRequest {
    return true;
}

export function CancelQuoteRequestFromJSON(json: any): CancelQuoteRequest {
    return CancelQuoteRequestFromJSONTyped(json, false);
}

export function CancelQuoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelQuoteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'adminComment': json['adminComment'] == null ? undefined : json['adminComment'],
    };
}

export function CancelQuoteRequestToJSON(value?: CancelQuoteRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'adminComment': value['adminComment'],
    };
}

